import { z } from 'zod';
import { RoleKey, ModuleKey, PermissionLevel } from '../enums.js';
export const loginInput = z.object({
    email: z.string().email().toLowerCase().trim(),
    password: z.string().min(6).max(200),
});
export const refreshInput = z.object({
    refreshToken: z.string().optional(),
});
export const userPublic = z.object({
    id: z.string(),
    email: z.string().email(),
    firstName: z.string(),
    lastName: z.string(),
    initials: z.string(),
    avatarColor: z.string(),
    active: z.boolean(),
    role: z.object({
        id: z.string(),
        key: z.nativeEnum(RoleKey).nullable(),
        name: z.string(),
        color: z.string(),
        shortLabel: z.string(),
        canSeeMargin: z.boolean(),
    }),
    permissions: z.array(z.object({
        module: z.nativeEnum(ModuleKey),
        level: z.nativeEnum(PermissionLevel),
    })),
});
export const loginResponse = z.object({
    user: userPublic,
    accessToken: z.string(),
});
//# sourceMappingURL=auth.js.map